import React, { useContext } from 'react';
import { IoHelpCircleOutline } from "react-icons/io5";
import { HelpContext } from '../context/help-context';

const Heading = ({ children, className }) => {
    // We use useContext directly here to avoid throwing errors if this component
    // is used outside of HelpProvider (e.g. in Login page).
    // If context is null, we simply don't render the help button.
    const context = useContext(HelpContext);

    return (
        <div className={`flex items-center gap-2 ${className || ''}`}>
            <h1 className={`lg:text-[22px] text-xl font-bold`}>
                {children}
            </h1>
            {context && context.toggleHelp && (
                <button
                    onClick={context.toggleHelp}
                    className='cursor-pointer text-gray-400 hover:text-primary transition-colors'
                    title="Get Help"
                >
                    <IoHelpCircleOutline className='text-2xl' />
                </button>
            )}
        </div>
    )
}

export default Heading;
